import { useQuery } from '@tanstack/react-query';
import { useParamsLegacy as useParams } from '@leagueplatform/routing';
import {
  DeserialisedUserChallengeRanksResponseData,
  getIndividualUserRank,
} from '@leagueplatform/health-journey-api';
import { useGetUserProfile } from '#hooks/use-get-user-profile.hook.ts';

export const INDIVIDUAL_USER_RANK_QUERY_KEY = 'getIndividualUserRankData';

export const useGetIndividualUserRank = () => {
  const { challengeId } = useParams<{ challengeId: string }>();
  const { data: userData } = useGetUserProfile();
  return useQuery<DeserialisedUserChallengeRanksResponseData, Error>(
    [INDIVIDUAL_USER_RANK_QUERY_KEY, challengeId],
    () => getIndividualUserRank(challengeId, userData?.user_id),
    { enabled: !!userData?.user_id },
  );
};
